
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Navigate, useLocation } from 'react-router-dom';
import Spinner from 'components/Spinner/Spinner';
import RidesStore from 'stores/Rides';
import UserStore from 'stores/User';
import styles from './PrivateRoute.module.scss';

const PrivateRoute = observer(({ children }) => {

  const [ ready, setReady ] = useState(false);
  const location = useLocation();

  useEffect(() => {
    fetchUserData();
  }, []);

  async function fetchUserData() {
    await UserStore.fetch();
    await RidesStore.fetch();
    setReady(true);
  }

  function isRidePath(path) {
    if (path.startsWith('/scooters/') || path.startsWith('/parking/')) {
      return true;
    }

    switch (path) {
      case '/ride':
      case '/ride/create':
      case '/ride/create/qr':
        return true;
      default: 
        return false;
    }
  }

  if (!ready) {
    return <div className={styles.spinner}><Spinner /></div>
  }

  if (!UserStore.id) {
    return <Navigate to="/auth" replace />
  }

  if (RidesStore.list?.length > 0 && !isRidePath(location.pathname)) {
    return <Navigate to="/ride" replace />
  }

  return children;
});

export default PrivateRoute;
